import React, { useEffect } from "react";
import { useTitle } from "../providers/title";

const Page = ({ title, children }) => {
  const { updateTitle } = useTitle();

  useEffect(() => {
    updateTitle(title);
  }, [title]);

  return <>{children}</>;
};

export default Page;
